import { Add } from "@mui/icons-material";
import { Button } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { Grid } from "@mui/material";
import { useSelector } from "react-redux";
import SelectEstablishment from "../selectEstablishment";
import { useNavigate } from "react-router-dom";

export default function PageActions() {
  const pageActions = useSelector((state) => state.pageActions);
  const navigate = useNavigate();

  if (pageActions.length === 0) return null;

  //for each action return a button in a grid, next to each other
  return pageActions.map((action) =>
    action.object ? (
      <Grid
        item
        sm={6}
        key={action.name}
        //flex items end
        sx={{
          display: "flex",
          justifyContent: { xs: "space-between", sm: "flex-end" },
        }}
      >
        {action.object}
      </Grid>
    ) : action.name === "SelectEstablishment" ? (
      <Grid item xs={11} sm={6} key={action.name}>
        <SelectEstablishment />
      </Grid>
    ) : (
      <Grid
        item
        xs={1} sm={6}
        key={action.name}
        sx={{
          //align content end
          display: "flex",
          justifyContent: { xs: "space-between", sm: "flex-end" },
          textAlign: "right",
        }}
      >
        {action.name === "MODIFIER" ? (
          <IconButton
            color="primary"
            onClick={() => {
              navigate(action.url);
            }}
            sx={{ 
              backgroundColor: "#6bc769",
              color: "white",
              "&:hover": {
                backgroundColor: "#5ba85f"
              }
            }}
          >
            "⚙️ TEST"
          </IconButton>
        ) : (
          <Button
            variant="contained"
            color="success"
            startIcon={<Add />}
            onClick={() => {
              if (action.action) {
                action.action();
              } else if (action.url) {
                navigate(action.url);
              }
            }}
          >
            {action.name}
          </Button>
        )}
      </Grid>
    )
  );
}
